import { RoleResponse } from "../../api-models/response/RoleResponse";
import { UserRoles } from "../../generated/Users";

export class Role {
  id: UserRoles;
  name: string;
  default: boolean;

  constructor(roleResponse: RoleResponse) {
    this.id = roleResponse.id;
    this.name = roleResponse.name;
    this.default = roleResponse.default;
  }

  get translationKey() {
    return `general.user.role.${this.name}`;
  }
}
